import { AxiosInstance } from "axios"
import { UserGroups } from "./importUsersTypes"
import { ImportResultData } from "../../../../../core/api/apiTypes"
import { createImportCsvFormData } from "../../../../../shared/components/importCsv/helpers"
import { ImportCsvFile } from "../../../../../shared/components/importCsv/importCsvFileTypes"

export enum CompanyIdCardsQuery {
    USER_GROUPS_FOR_COMPANY = "user-groups-for-company",
}

type UserGroupsParams = Readonly<{
    companyId: number
}>
export type UserGroupsResponse = Readonly<{
    userGroups: UserGroups[]
}>

export async function fetchUserGroupsForCompany(
    { companyId }: UserGroupsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UserGroupsResponse> {
    const url = `/companies/${companyId}/userGroups`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

type ImportUsersParams = Readonly<{
    companyId: number
    importData: ImportCsvFile
}>

export async function importUsers(
    { companyId, importData }: ImportUsersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ImportResultData> {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        signal,
    }

    const { data } = await axios.post(
        `/companies/${companyId}/users/import`,
        createImportCsvFormData(importData),
        config,
    )

    return data
}
